<template>
  <div v-if="currentCategory">
    <notifications group="foo" />
    <Breadcrumb class="breadcrumb-list" @navigateTo="selectCategory" v-if="!buildYourJewelMode"></Breadcrumb>
    <div class="col row px-0 ml-0 mt-2 results" :class="{ 'bg-theme-2': theme !== 1, 'ama-results': isAma }"
      v-if="!isSearching">
      <!-- mobile -->
      <div class="col-12 text-center d-md-none px-0">
        <h5 v-if="searchJewel.text">
          {{ $t("searchResultsFor") }} "{{ searchJewel.text }}"
        </h5>
        <div v-if="step === 1">
          <div class="text-center side-part-mobile mb-3" :class="{ 'side-part-mobile-2': theme === 2 }"
            v-for="subCategory in subCategories" :key="subCategory.id" v-on:click="
              selectSub(subCategory.id !== subCategorySelectedId ? subCategory : null);
            step = 2;
            ">
            <div class="row mx-0 subcategory-mobile">
              <div class="col-5">
                <div class="border-item-mobile">
                  <img :src="baseImageUrl + subCategory.imgPath" class="w-100 p-2" />
                </div>
              </div>
              <div class="col text-left py-2 px-1">
                <h3 class="mb-0" :class="[theme === 1 ? 'py-5' : 'category-mobile-name py-4 pl-2']">
                  {{ subCategory.name }}
                </h3>
                <div class="text-right" :class="['show-all-btn-' + theme]">
                  <button class="btn btn-primary text-lowercase" :class="currentCategory.productType">
                    {{ $t("show_all") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step === 2">
          <div class="text-center">
            <div class="swiper-container">
              <div class="swiper-slides">
                <div v-swiper:mySwiper="swiperOptions">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide mobile-stone" :key="stone.id" v-for="stone in stoneTypes">
                      <img :src="baseImageUrl + stone.image" class="w-100 mt-1 mb-1" v-on:click="
                        selectStone(stone.id !== stoneTypeSelectedId ? stone : null)
                        " />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-pagination"></div>-->
          </div>
        </div>
      </div>

      <div class="col-3 col-lg-2 h-100 pl-0 side-part d-none d-md-block" v-if="theme === 1">
        <div v-if="
          isGioielleriaItalianaB2B && this.currentCategory.productType === 'JEWELLERY'
        ">
          <div class="rounded-side-filter mt-2 border-left-0">
            <p class="text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase">
              {{ $t("section") }}
            </p>
          </div>
          <div v-for="section in jewelSections" :key="section" v-if="section != 'OFF_PLATFORM' || credential.isBO"
            class="labelCatFilterDiv form-check text-left pl-5">
            <label class="form-check-label labelCatFilter cursor-pointer" :for="section + 'Checkbox'">
              {{ $t(section) }}
            </label>
            <input :id="section + 'Checkbox'" class="form-check-input" type="checkbox"
              :checked="isSectionChecked(section)" @change="toggleSectionFilter(section)" />
          </div>
          <div class="labelCatFilterDiv form-check text-left pl-5">
            <label class="form-check-label labelCatFilter cursor-pointer" for="fastDeliveryCheckbox">
              {{ $t("fastDelivery") }}
            </label>
            <input id="fastDeliveryCheckbox" class="form-check-input" type="checkbox"
              :checked="searchJewel.minAvailability > 0" @change="onChangeFastDelivery()" />
          </div>
        </div>
        <div v-if="isAma && this.currentCategory.productType === 'AMA_JEWELLERY'">
          <div class="rounded-side-filter mt-2 border-left-0">
            <p class="text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase">
              {{ $t("section") }}
            </p>
          </div>
          <div class="labelCatFilterDiv form-check text-left pl-5">
            <label class="form-check-label labelCatFilter cursor-pointer" for="newin_checkbox">
              {{ $t("NEW_IN") }}
            </label>
            <input id="newin_checkbox" class="form-check-input" type="checkbox" :checked="isSectionChecked('NEW_IN')"
              @change="toggleSectionFilter('NEW_IN')" />
          </div>
          <div v-if="!isSectionChecked('AMA_COLORE')" class="labelCatFilterDiv form-check text-left pl-5">
            <label class="form-check-label labelCatFilter cursor-pointer" for="aria_checkbox">
              {{ $t("aria_collection") }}
            </label>
            <input id="aria_checkbox" class="form-check-input" type="checkbox" :checked="isSectionChecked('ARIA')"
              @change="toggleSectionFilter('ARIA')" />
          </div>
          <div v-if="credential.isBO" class="labelCatFilterDiv form-check text-left pl-5">
            <label class="form-check-label labelCatFilter cursor-pointer" for="offPlatform_checkbox">
              {{ $t("OFF_PLATFORM") }}
            </label>
            <input id="offPlatform_checkbox" class="form-check-input" type="checkbox"
              :checked="isSectionChecked('OFF_PLATFORM')" @change="toggleSectionFilter('OFF_PLATFORM')" />
          </div>
        </div>
        <div v-if="getFilteredCategories(currentCategory.productType).length > 1">
          <div class="rounded-side-filter mt-2 border-left-0">
            <p class="text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase"
              :class="currentCategory.productType">
              {{ $t("category") }}
            </p>
          </div>
          <div class="labelCatFilterDiv form-check text-left pl-5"
            v-for="category in getFilteredCategories(currentCategory.productType)" :key="category.id" v-on:click="
              selectCategory(
                category.id !== currentCategory.id
                  ? category
                  : { productType: currentCategory.productType }
              )
              ">
            <label class="form-check-label labelCatFilter cursor-pointer" :for="category.id">
              {{ category.name }}
            </label>
            <input class="form-check-input" type="checkbox" :checked="currentCategory.id == category.id" />
          </div>
        </div>
        <div v-if="currentCategory.id && subCategories.length > 1">
          <div class="rounded-side-filter mt-2 border-left-0">
            <p class="text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase"
              :class="currentCategory.productType" v-on:click="selectSub()">
              {{ $t("models") }}
            </p>
          </div>
          <div class="labelCatFilterDiv form-check text-left pl-5" v-for="subCategory in subCategories"
            :key="subCategory.id" v-on:click="
              selectSub(subCategory.id !== subCategorySelectedId ? subCategory : null)
              ">
            <label class="form-check-label labelCatFilter cursor-pointer" :for="subCategory.id">
              {{ subCategory.name }}
            </label>
            <input class="form-check-input" type="checkbox" :checked="subCategorySelectedId == subCategory.id" />
          </div>
        </div>
        <div v-if="!buildYourJewelMode">
          <div class="rounded-side-filter mt-2 border-left-0" v-if="stoneTypes.length > 0">
            <p class="text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase"
              :class="currentCategory.productType" v-on:click="selectStone(null)">
              {{ $t("stoneType") }}
            </p>
          </div>
          <div class="text-left pl-5">
            <p class="stone-type-title" v-if="!currentCategory.productType">
              {{ $t("jewelleryStones") }}
            </p>
            <img v-for="stone in stoneTypes.filter((s) => s.jewellery)" :key="stone.color"
              :src="baseImageUrl + stone.image" height="40" width="40" class="rounded-circle mt-2 cursor-pointer"
              :style="{ border: stoneTypeSelectedId == stone.color ? '1px solid' : '' }"
              v-on:click="selectStone(stone.color !== stoneTypeSelectedId ? stone : null)"
              v-tooltip.top="{ content: stone.name }" />
            <p class="stone-type-title" v-if="!currentCategory.productType">
              {{ $t("goldsmithStones") }}
            </p>
            <img v-for="stone in stoneTypes.filter((s) => !s.jewellery)" :key="stone.color"
              :src="baseImageUrl + stone.image" height="40" width="40" class="rounded-circle mt-2 cursor-pointer"
              :style="{ border: stoneTypeSelectedId == stone.color ? '1px solid' : '' }"
              v-on:click="selectStone(stone.color !== stoneTypeSelectedId ? stone : null)"
              v-tooltip.top="{ content: stone.name }" />
          </div>
        </div>

        <div v-if="
          buildYourJewelMode &&
          stoneShapes.length > 1 &&
          buildYourJewelMode == 'SETTING'
        ">
          <div class="rounded-side-filter mt-2 border-left-0">
            <p class="text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase"
              :class="currentCategory.productType" v-on:click="selectStoneShape(null)">
              {{ $t("stoneShape") }}
            </p>
          </div>
          <div class="text-left pl-5">
            <img v-for="shape in stoneShapes" :key="shape.id" :src="getShapeImage(shape.id)" height="40" width="40"
              class="rounded-circle mt-2 cursor-pointer"
              :style="{ border: stoneShapeSelectedId == shape.id ? '1px solid' : '' }" v-on:click="
                selectStoneShape(shape.id !== stoneShapeSelectedId ? shape : null)
                " v-tooltip.top="{ content: shape.id }" />
          </div>
        </div>

        <div class="rounded-side-filter mt-2 border-left-0" v-if="!isAccessoryCategory">
          <p class="text-left pl-5 titleCatFilter cursor-pointer font-weight-bold text-uppercase"
            :class="currentCategory.productType" v-on:click="selectGold()">
            {{ $t("goldColor") }}
          </p>
        </div>
        <div class="text-left pl-5" v-if="!isAccessoryCategory">
          <img v-for="gold in golds" :key="gold.id" :src="baseImageUrl + gold.image" height="40" width="40"
            class="rounded-circle mt-2 mr-2 cursor-pointer" :style="{
              border: goldSelectedId == gold.goldType ? '1px solid' : '',
            }" v-on:click="selectGold(gold.goldType !== goldSelectedId ? gold : null)" />
        </div>

        <div class="rounded-side-filter mt-2" style="border-left: none !important">
          <p class="text-left py-2 pl-5 font-weight-bold text-uppercase titleCatFilter"
            :class="currentCategory.productType">
            {{ $t("priceRange") }}
          </p>
        </div>
        <div class="mb-0 mt-3 pl-4 pr-2" style="height: 70px">
          <div class="d-none d-xl-block">
            <vue-slider v-model="value" :marks="marks1" :enable-cross="false" :lazy="true" ref="slider"
              :tooltip-formatter="formatter" :dot-size="40" :process="false" :min="0" :max="2000"
              @change="searchByRange">
              <template v-slot:dot="{ }">
                <!-- <div :class="['custom-dot', { focus }]"></div> -->
                <img class="custom-dot cursor-pointer" src="../assets/slider-1.png" alt />
              </template>
            </vue-slider>
          </div>
          <div class="d-block d-xl-none">
            <vue-slider v-model="value" :marks="marks2" :enable-cross="false" :lazy="true" ref="slider"
              :tooltip-formatter="formatter" :dot-size="40" :process="false" :min="0" :max="2000"
              @change="searchByRange">
              <template v-slot:dot="{ }">
                <!-- <div :class="['custom-dot', { focus }]"></div> -->
                <img class="custom-dot cursor-pointer" src="../assets/slider-1.png" alt />
              </template>
            </vue-slider>
          </div>
        </div>
      </div>
      <div class="col-12 col-0 h-100 py-3 d-none d-md-block" v-if="theme === 2">
        <div class="row">
          <div class="col-6 row">
            <div class="col-6" style="align-self: center">
              <p class="text-left text-uppercase label-menu" style="font-size: 14px">
                {{ $t("models") }}
              </p>
            </div>
            <div class="col-6" style="align-self: center">
              <select class="row w-100" @change="selectSub(subCategoryObjSelected)" v-model="subCategoryObjSelected">
                <option :value="null"></option>
                <option v-for="subCategory in subCategories" :key="subCategory.id" :value="subCategory">
                  {{ subCategory.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-4 row" style="align-self: center">
                <p class="text-left text-uppercase label-menu" style="font-size: 14px"
                  :class="currentCategory.productType">
                  {{ $t("priceRange") }}
                </p>
              </div>
              <div class="col-8">
                <div class="mb-0 mt-3 pl-4 pr-2" style="height: 70px">
                  <div class="d-none d-xl-block">
                    <vue-slider v-model="value" :marks="marks1" :enable-cross="false" :lazy="true" ref="slider"
                      :tooltip-formatter="formatter" :dot-size="40" :process="false" :min="0" :max="2000"
                      @change="searchByRange">
                      <template v-slot:dot="{ }">
                        <!-- <div :class="['custom-dot', { focus }]"></div> -->
                        <img class="custom-dot cursor-pointer" src="../assets/slider-1.png" alt />
                      </template>
                    </vue-slider>
                  </div>
                  <div class="d-block d-xl-none">
                    <vue-slider v-model="value" :marks="marks2" :enable-cross="false" :lazy="true" ref="slider"
                      :tooltip-formatter="formatter" :dot-size="40" :process="false" :min="0" :max="2000"
                      @change="searchByRange">
                      <template v-slot:dot="{ }">
                        <!-- <div :class="['custom-dot', { focus }]"></div> -->
                        <img class="custom-dot cursor-pointer" src="../assets/slider-1.png" alt />
                      </template>
                    </vue-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 row">
            <div class="col-2" style="align-self: center">
              <p class="text-left text-uppercase label-menu" style="font-size: 14px">
                {{ $t("stoneType") }}
              </p>
            </div>
            <div class="col-10">
              <img v-for="stone in stoneTypes" :key="stone.color" :src="baseImageUrl + stone.image" height="25"
                width="25" class="rounded-circle mt-2 cursor-pointer"
                :style="{ border: stoneTypeSelectedId == stone.color ? '1px solid' : '' }" v-on:click="
                  selectStone(stone.color !== stoneTypeSelectedId ? stone : null)
                  " v-tooltip.top="{ content: stone.name }" />
            </div>
          </div>

          <div class="col-6 row">
            <div class="col-4 pl-0" style="align-self: center">
              <p class="text-left text-uppercase label-menu" style="font-size: 14px">
                {{ $t("goldColor") }}
              </p>
            </div>
            <div class="col-8" style="align-self: center">
              <img v-for="gold in golds" :key="gold.id" :src="baseImageUrl + gold.image" height="25" width="25"
                class="rounded-circle mt-2 mr-2 cursor-pointer float-left" :style="{
                  border: goldSelectedId == gold.goldType ? '1px solid' : '',
                }" v-on:click="selectGold(gold.goldType !== goldSelectedId ? gold : null)" />
            </div>
          </div>
        </div>
        <!-- <div class="rounded-side-filter mt-2 border-left-0">
          <p class="text-left pl-4 font-weight-bold text-uppercase">{{$t('search')}}</p>
        </div>-->
      </div>
      <div :class="[
        theme === 1
          ? 'col-12 col-md-9 col-lg-10'
          : step === 1
            ? 'col-md-12 bg-list'
            : 'col-md-12',
      ]">
        <div v-if="currentCategory.productType == 'GOLDSMITH'">
          <b-alert variant="warning" show>
            {{ $t("goldsmith_pieces_warning") }}
          </b-alert>
        </div>

        <div class="row" v-if="isAma">
          <b-tabs content-class="mt-3" align="center" class="collection-tab">
            <b-tab :active="!isSectionChecked('AMA_COLORE')"
              @click="setSectionsFilter([], false);">
              <template #title>
                <strong>{{ $t('traditional_collections') }}</strong>
              </template>
            </b-tab>
            <b-tab :active="isSectionChecked('AMA_COLORE')"
              @click="setSectionsFilter(['AMA_COLORE'], false);">
              <template #title>
                <strong>{{ $t('ama_color_collection') }} <span class="new-feature"></span></strong>
              </template>
            </b-tab>
          </b-tabs>
        </div>

        <div class="col-12 d-none d-md-block text-right" v-if="!isSearching">
          <select class="select-setting" @change="sortList(selectedFilter)" v-model="selectedFilter"
            :class="[theme === 1 ? 'mt-3' : 'mt-2']">
            <option value disabled selected>{{ $t("orderBy") }}</option>
            <option v-for="option in sortOptions" :key="option.id" :value="option.id">
              {{ $t(`${option.label}`) }}
            </option>
          </select>
        </div>
        <div class="col-12 filters-tags">
          <div v-for="section in jewelSections" :key="section + '-filter'" class="filter-tag"
            v-if="isSectionChecked(section)">
            <span class="label">{{ $t(section) }}</span>
            <span class="remove-filter-icon">
              <font-awesome-icon :icon="['fa', 'times']" v-on:click="toggleSectionFilter(section)" />
            </span>
          </div>
          <div class="filter-tag" v-if="searchJewel.minAvailability > 0">
            <span class="label">{{ $t("fastDelivery") }}</span>
            <span class="remove-filter-icon">
              <font-awesome-icon :icon="['fa', 'times']" v-on:click="onChangeFastDelivery(0)" />
            </span>
          </div>
          <!-- <div class="filter-tag" v-if="categoryFilter">
            <span class="label">{{ categoryFilter.name }}</span>
            <span class="remove-filter-icon"
              ><font-awesome-icon
                :icon="['fa', 'times']"
                v-on:click="selectCategory(null)"
            /></span>
          </div> -->
          <div class="filter-tag" v-if="subCategoryFilter">
            <span class="label">{{ subCategoryFilter.name }}</span>
            <span class="remove-filter-icon">
              <font-awesome-icon :icon="['fa', 'times']" v-on:click="selectSub(null)" />
            </span>
          </div>
          <div class="filter-tag" v-if="stoneFilter && stoneFilter.name">
            <span class="label">{{ stoneFilter.name }}</span>
            <span class="remove-filter-icon">
              <font-awesome-icon :icon="['fa', 'times']" v-on:click="selectStone(null)" />
            </span>
          </div>
          <div class="filter-tag" v-if="stoneShapeFilter && stoneShapeFilter.name">
            <span class="label">{{ stoneShapeFilter.name }}</span>
            <span class="remove-filter-icon">
              <font-awesome-icon :icon="['fa', 'times']" v-on:click="selectStoneShape(null)" />
            </span>
          </div>
          <div class="filter-tag" v-if="goldFilter">
            <span class="label">{{ $t("gold_" + goldFilter.goldType) }}</span>
            <span class="remove-filter-icon">
              <font-awesome-icon :icon="['fa', 'times']" v-on:click="selectGold(null)" />
            </span>
          </div>
          <div class="filter-tag" v-if="value[0] || value[1] != 2000">
            <span class="label" v-if="value[0] && value[1] != 2000">{{
              value[0] + " € - " + value[1] + " €"
            }}</span>
            <span class="label" v-else-if="value[0]">&gt; {{ value[0] }} €</span>
            <span class="label" v-else-if="value[1] != 2000">&lt; {{ value[1] }} €</span>
            <span class="remove-filter-icon">
              <font-awesome-icon :icon="['fa', 'times']" v-on:click="resetPriceRenge()" />
            </span>
          </div>
        </div>
        <div class="row infinite-list" v-if="jewelList && jewelList.length > 0">
          <div v-if="isAma && !isSectionChecked('AMA_COLORE')" v-for="amaKit in amaKits" class="col-6 mb-3"
            :class="[theme === 1 ? 'col-md-6 col-lg-4 col-xl-3' : 'col-md-4 col-xl-3']">
            <StarterKit :name="amaKit.name" :label="amaKit.label"></StarterKit>
          </div>
          <div v-if="isAma && !isSectionChecked('AMA_COLORE')" v-for="amaKit in amaAriaKits" class="col-6 mb-3"
            :class="[theme === 1 ? 'col-md-6 col-lg-4 col-xl-3' : 'col-md-4 col-xl-3']">
            <StarterKit :name="amaKit.name" :label="amaKit.label"></StarterKit>
          </div>
          <div v-if="isGioielleriaItalianaB2B && isSectionChecked('ESSENTIAL')" v-for="giKit in giKits"
            class="col-6 mb-3" :class="[theme === 1 ? 'col-md-6 col-lg-4 col-xl-3' : 'col-md-4 col-xl-3']">
            <StarterKit :name="giKit.name" :label="giKit.label"></StarterKit>
          </div>
          <div class="col-6 mb-3 cursor-pointer d-flex"
            :class="[theme === 1 ? 'col-md-6 col-lg-4 col-xl-3' : 'col-md-4 col-xl-3']"
            v-for="jewel in jewelList.slice(0, jewelsToShow)" :key="jewel.sku" :id="'jewel-' + jewel.sku"
            v-if="jewel.productType !== 'KIT' || !isAma || !showOnlyPublicPrice" v-on:click="goToJewelDetail(jewel)">
            <div class="flex-grow-1" :class="[
              theme === 1 ? 'border-item' : 'border-item-2',
              currentCategory.productType,
            ]">
              <div class="icons" v-if="isGioielleriaItalianaB2B">
                <div class="fast-delivery-icon" v-if="jewel.fastDeliveryItems && jewel.fastDeliveryItems.length > 0">
                  <img v-tooltip="$t('fastDelivery')" :src="baseImageUrl + '/configuratore/icons/fast_delivery.png'" />
                </div>

                <div class="bestseller-icon" v-if="jewel.jewelSections && jewel.jewelSections.includes('BESTSELLER')">
                  <font-awesome-icon v-tooltip="$t('bestseller')" :icon="['fa', 'trophy']" />
                </div>
              </div>

              <div class="position-relative bg-white image-list">
                <div v-if="jewel.images && jewel.images.length > 1" :id="'jewel-swiper-' + jewel.sku"
                  class="swiper-container jewel-swiper-container" v-swiper="getJewelSwiperOptions(jewel.sku)">
                  <div class="swiper-wrapper jewel-swiper">
                    <div class="swiper-slide" v-for="(img, idx) in jewel.images" :key="idx">
                      <img class="jewel-image" :src="baseImageUrl + img" loading="lazy" />
                    </div>
                  </div>

                  <!-- pagination bullets -->
                  <div class="swiper-pagination" @click.stop.prevent @pointerdown.stop></div>

                  <!-- navigation arrows 
                  <div class="swiper-button-prev" role="button" aria-label="Previous slide" @click.stop.prevent @pointerdown.stop></div>
                  <div class="swiper-button-next" role="button" aria-label="Next slide" @click.stop.prevent @pointerdown.stop></div>-->
                </div>
                <img v-else class="jewel-image"
                  :src="jewel.image ? baseImageUrl + jewel.image : (jewel.images && jewel.images.length ? baseImageUrl + jewel.images[0] : '')" />

                <div class="name-back">
                  <div class="name-space" :class="jewel.productType">
                    <span class="mb-0 sku" :class="jewel.productType" v-if="isAma">{{
                      jewel.sku
                    }}</span>
                    <span class="mb-0 name" :class="jewel.productType">{{
                      jewel.name
                    }}</span>
                    <div v-if="buildYourJewelMode" class="value">
                      {{ $t("from") + " " + jewel.minGoldWeight + " "
                      }}<span style="text-transform: lowercase">g</span>
                    </div>
                    <div v-else class="value">
                      {{ $t("from") }} €
                      <span v-if="!showOnlyPublicPrice">{{
                        retailPerc === 1
                          ? parseFloat(jewel.minPrice * vat)
                            .toFixed(0)
                            .toLocaleString("it-it")
                          : parseFloat(
                            (jewel.minPrice * retailPerc).toFixed(0)
                          ).toLocaleString("it-it")
                      }}
                      </span>
                      <span v-if="showOnlyPublicPrice">
                        {{
                          parseFloat(jewel.listPrice.toFixed(0)).toLocaleString("it-it")
                        }}
                      </span>
                    </div>
                  </div>
                </div>

                <div v-if="
                  !buildYourJewelMode &&
                  jewel.stoneColors &&
                  jewel.stoneColors.length > 0
                " class="jewel-stone-colors w-100" :style="{ 'background-color': theme === 1 ? '' : 'white' }"
                  style="bottom: 0px; padding-bottom: 4px">
                  <img v-for="stoneColor in jewel.stoneColors" :key="stoneColor"
                    :src="baseImageUrl + getStoneByColor(stoneColor).image"
                    class="rounded-circle cursor-pointer inside-stone" />
                </div>

                <div v-if="
                  buildYourJewelMode &&
                  jewel.stoneShapes &&
                  jewel.stoneShapes.length > 0
                " class="jewel-stone-colors w-100" :style="{ 'background-color': theme === 1 ? '' : 'white' }"
                  style="bottom: 0px; padding-bottom: 4px">
                  <img v-for="stoneShape in jewel.stoneShapes" :key="stoneShape" :src="getShapeImage(stoneShape)"
                    v-tooltip.top="{ content: stoneShape }" class="rounded-circle cursor-pointer inside-stone" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 text-md-right text-center">
            <button class="btn text-uppercase" :class="['btn-show-' + theme, currentCategory.productType]"
              v-on:click="showMore()">
              {{ jewelList.length > jewelsToShow ? $t("showMore") : $t("showLess") }}
            </button>
          </div>
        </div>
        <div class="row mt-5" v-else-if="jewelList && jewelList.length === 0">
          <div class="col-12 mb-3 text-center justify-content-center">
            <img src="../assets/slider-1.png" alt height="100" width="100" />
            <h1>{{ $t("noJewels") }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="isSearching">
      <div class="col-12 mb-3 text-center justify-content-center mt-5">
        <DoubleBounce background="#00274F" size="100px"></DoubleBounce>
      </div>
    </div>
  </div>
</template>

<script>
import ListItem from "./ListItem.vue";
import Breadcrumb from "./Breadcrumb.vue";
import { mapActions, mapMutations, mapState } from "vuex";

import { DoubleBounce } from "vue-loading-spinner";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import Vue from "vue";
import ToggleButton from "vue-js-toggle-button";
import StarterKit from "./StarterKit.vue";

Vue.use(ToggleButton);

export default {
  name: "SubListSection",
  data: function () {
    return {
      step: 1,
      // currentCategory: null,
      retailPerc: 1,
      vat: 1,
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
      jewelsToShow: 400,
      selectedFilter: "",
      textToSearch: "",
      value: [0, 2000],
      formatter: (v) => (v === 2000 ? "> 2000 €" : `${v} €`),
      marks1: {
        300: {
          label: this.$t("to300"),
          style: {
            width: "4px",
            height: "10px",
            display: "block",
            backgroundColor: "white",
            borderRadius: "0%",
            transform: "translate(-2px, -2px)",
          },
          processStyle: {
            backgroundColor: "red",
          },
          labelStyle: { fontSize: "10px", marginTop: "15px" },
        },
        600: {
          label: this.$t("to600"),
          style: {
            width: "4px",
            height: "10px",
            display: "block",
            backgroundColor: "white",
            borderRadius: "0%",
            transform: "translate(-2px, -2px)",
          },
          labelStyle: { fontSize: "10px", marginTop: "15px" },
        },
        1500: {
          label: this.$t("to1500"),
          style: {
            width: "4px",
            height: "10px",
            display: "block",
            backgroundColor: "white",
            borderRadius: "0%",
            transform: "translate(-2px, -2px)",
          },
          sliderStyle: {
            height: "15px",
          },
          labelStyle: { fontSize: "10px", marginTop: "15px" },
        },
        2000: {
          label: this.$t("from2000"),
          style: {
            width: "4px",
            height: "10px",
            display: "block",
            backgroundColor: "white",
            borderRadius: "0%",
            transform: "translate(-2px, -2px)",
          },
          labelStyle: { fontSize: "10px", marginTop: "15px" },
        },
      },
      marks2: {
        300: {
          label: this.$t("to300"),
          style: {
            width: "4px",
            height: "10px",
            display: "block",
            backgroundColor: "white",
            borderRadius: "0%",
            transform: "translate(-2px, -2px)",
          },
          processStyle: {
            backgroundColor: "red",
          },
          labelStyle: { fontSize: "10px", marginTop: "15px" },
        },
        // 600: {
        //   label: this.$t("to600"),
        //   style: {
        //     width: "4px",
        //     height: "10px",
        //     display: "block",
        //     backgroundColor: "white",
        //     borderRadius: "0%",
        //     transform: "translate(-2px, -2px)"
        //   },
        //   labelStyle: { fontSize: "10px", marginTop: "15px" }
        // },
        // 1500: {
        //   label: this.$t("from600To1500"),
        //   style: {
        //     width: "4px",
        //     height: "10px",
        //     display: "block",
        //     backgroundColor: "white",
        //     borderRadius: "0%",
        //     transform: "translate(-2px, -2px)"
        //   },
        //   sliderStyle: {
        //     height: "15px"
        //   },
        //   labelStyle: { fontSize: "10px", marginTop: "15px" }
        // },
        2000: {
          label: this.$t("from2000"),
          style: {
            width: "4px",
            height: "10px",
            display: "block",
            backgroundColor: "white",
            borderRadius: "0%",
            transform: "translate(-2px, -2px)",
          },
          labelStyle: { fontSize: "10px", marginTop: "15px" },
        },
      },
      sortOptions: [
        { id: "suggested", label: "suggested" },
        {
          id: "name",
          label: "name",
        },
        { id: "price", label: "price" },
      ],
      subCategorySelectedId: null,
      subCategoryObjSelected: null,
      subStoneTypeObjSelected: null,
      stoneShapeSelectedId: null,
      stoneTypeSelectedId: null,
      stoneTypeSelectedLabel: null,
      goldSelectedId: null,
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      jewelSwiperOptions: {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
        },
      },
      jewelSections: ["OFF_PLATFORM", "NEW_IN", "ESSENTIAL", "AMULETO", "BESTSELLER"],
      giKits: [
        { name: "ESSENTIAL_A", label: "ESSENTIAL PACK A" },
        { name: "ESSENTIAL_B", label: "ESSENTIAL PACK B" },
      ],
      amaKits: [
        { name: "AMA_STARTER", label: "10 PZ" },
      ],
      amaAriaKits: [
        { name: "AMA_ARIA", label: "KIT ARIA" },
      ],
    };
  },
  components: {
    ListItem,
    VueSlider,
    DoubleBounce,
    Breadcrumb,
    StarterKit,
  },
  directives: {
    swiper: directive,
  },
  computed: {
    categoryFilter: function () {
      return this.categories.find((cat) => cat.id == this.currentCategory.id);
    },
    subCategoryFilter: function () {
      return this.subCategories.find((sub) => sub.id == this.subCategorySelectedId);
    },
    goldFilter: function () {
      return this.golds.find((g) => g.goldType == this.goldSelectedId);
    },
    stoneFilter: function () {
      return this.allStoneTypes.find((s) => s.color == this.stoneTypeSelectedId);
    },
    stoneShapeFilter: function () {
      return this.stoneShapes.find((s) => s.id == this.stoneShapeSelectedId);
    },
    isAccessoryCategory: function () {
      return Vue.isAccessory(this.currentCategory.productType);
    },
    ...mapState({
      theme: (state) => state.config.theme,
      lastSelectedJewel: (state) => state.list.lastSelectedJewel,
      currentCategory: (state) => state.list.currentCategory,
      jewelList: (state) => state.list.jewels,
      categories: (state) => state.list.categories,
      subCategories: (state) => state.list.subCategoriesToShow,
      stoneTypes: (state) => state.list.stoneTypes,
      stoneShapes: (state) => state.list.stoneShapes,
      allStoneTypes: (state) => state.list.allStoneTypes,
      golds: (state) => state.list.golds,
      searchJewel: (state) => state.list.searchJewel,
      isSearching: (state) => state.list.isSearching,
      selectedStyle: (state) => state.list.style,
      isGioielleriaItalianaB2B: (state) => state.config.isGioielleriaItalianaB2B,
      origin: (state) => state.detail.origin,
      buildYourJewelMode: (state) => state.buildYourJewel.buildYourJewelMode,
      isAma: (state) => state.config.isAma,
      showOnlyPublicPrice: (state) => state.config.showOnlyPublicPrice,
      buildYourJewelSelectedStone: (state) => state.buildYourJewel.selectedStones,
      buildYourJewelStonesNumber: (state) => state.buildYourJewel.stonesNumber,
      credential: (state) => state.config.credential,
      swiper() {
        return this.$refs.mySwiper.$swiper;
      },
    }),
  },
  mounted() {
    const urlSections = this.$route.query.section
      ? this.$route.query.section.split(",")
      : [];

    if (!!urlSections.filter((section) => section !== "FAST_DELIVERY")) {
      this.setJewelSection(urlSections.filter((section) => section !== "FAST_DELIVERY"));
    }

    this.setExcludeJewelSection(this.$route.query.excludeSection ? this.$route.query.excludeSection.split(",") : []);

    this.setMinAvailability(
      urlSections.includes("FAST_DELIVERY") || this.searchJewel.minAvailability > 0
        ? 1
        : 0
    );

    this.subCategorySelectedId = this.searchJewel.subCategory;
    this.getCategories();
    this.retailPerc = this.$store.state.detail.retailPerc;
    this.vat = this.$store.state.detail.vat;
    this.stoneTypeSelectedId = this.searchJewel.stoneColor;
    this.stoneShapeSelectedId = this.searchJewel.stoneShape;
    this.goldSelectedId = this.searchJewel.goldColor;
    this.textToSearch = this.searchJewel.text;
    if (this.searchJewel.text && this.searchJewel.text != "") this.step = 0;
    this.jewelsToShow = this.searchJewel.numberOfElements || 400;
    Vue.set(this.value, 0, this.searchJewel.minPrice || 0);
    Vue.set(
      this.value,
      1,
      !!this.searchJewel.maxPrice ? this.searchJewel.maxPrice : 2000
    );
    this.selectedFilter = !!this.searchJewel.sorting
      ? this.searchJewel.sorting
      : "suggested";
  },
  created() {
    this.scrollPage();
  },
  beforeRouteLeave(to, from, next) {
    if (from.name == "list.sublist" && to.name == "list" && this.isMobile()) {
      if (this.step === 2 && window.event.type == "popstate") {
        this.step = 1;
        Vue.setHeight();
        return next(false);
      } else {
        return next();
      }
    } else {
      return next();
    }
  },
  watch: {
    searchJewel: {
      handler: function (newValue, oldValue) {
        if (this.searchJewel.text && this.searchJewel.text != "") {
          this.textToSearch = this.searchJewel.text;
          this.goldSelectedId = null;
          this.stoneTypeSelectedId = null;
          this.stoneTypeSelectedLabel = null;
          this.stoneShapeSelectedId = null;
          this.subCategorySelectedId = null;
          this.getListStoneColors(this.getStonePayload("stone-colors"));
          this.getListStoneShapes(this.getStonePayload("stone-shapes"));
          this.step = 0;
        }
      },
      deep: true,
    },
    jewelList: function () {
      Vue.setHeight();
    },
    jewelsToShow: function () {
      Vue.setHeight();
    },
    "$route.params.workType": function (workType) {
      this.setSubCat();
      this.resetSelectedStoneObj();
      this.resetSelectedStoneSizeObj();
    },
  },
  methods: {
    ...mapActions("list", [
      "search",
      "getListSubCategories",
      "getListStoneColors",
      "getListStoneShapes",
      "getListAllStoneColors",
      "getListGoldTypes",
      "getListCategoriesWithCb",
    ]),
    ...mapMutations("list", [
      "setJewelSearch",
      "resetJewelSearch",
      "setStyle",
      "setLastSelectedJewel",
      "setJewelsList",
      "setSearching",
      "setCurrentCategory",
    ]),
    ...mapMutations("detail", [
      "resetStoneObj",
      "resetCurrentJewel",
      "resetSelectedStoneSizeObj",
      "resetCurrentCategory",
      "resetCurrentJewel",
      "resetDetail",
      "setPreselectedJewel",
    ]),
    ...mapMutations("productDetail", { resetCurrentProduct: "resetCurrentJewel" }),
    ...mapActions("list", ["getListCategories"]),
    ...mapActions("buildYourJewel", ["selectSetting"]),
    sortList(sortValue) {
      this.setJewelSearch({
        label: "sorting",
        value: sortValue !== "" ? sortValue : null,
      });
      this.search(this.searchJewel);
      this.scrollTo(0);
    },
    getCategories() {
      const vm = this;
      this.setSearching(true);
      this.getListCategoriesWithCb({
        search: "categories",
        cb: (res) => {
          this.getListAllStoneColors(this.getStonePayload("stone-colors"));
          this.setSubCat();
          this.resetStoneObj();
          this.resetCurrentJewel();
          this.resetCurrentProduct();
          this.resetSelectedStoneSizeObj();
        },
        params: {
          jewelStonesNumber: this.buildYourJewelStonesNumber,
        },
      });
    },
    scrollPage() {
      setTimeout(() => {
        /*document.addEventListener('scroll', e => {
          const listElm = document.querySelector('.infinite-list');
          if (listElm && document.documentElement.scrollTop + window.innerHeight >= listElm.scrollHeight) {
            this.showMore();
          }
        });*/

        let h = 0;
        if (this.lastSelectedJewel && !this.textToSearch) {
          let el;
          el = document.getElementById("jewel-" + this.lastSelectedJewel);
          if (el) {
            h = el.offsetTop;
          } else {
            this.scrollPage();
          }
          if (h) {
            this.scrollTo(h);
            this.setLastSelectedJewel();
          }
        } else {
          this.scrollTo(h);
          this.setLastSelectedJewel();
        }
      }, 1200);
    },
    scrollTo(height) {
      window.parent.postMessage(
        {
          func: "setGioielleriaItalianaScroll",
          message: height,
        },
        "*"
      );
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    showMore() {
      this.jewelsToShow =
        this.jewelList.length > this.jewelsToShow ? this.jewelsToShow + 400 : 16;
      //this.jewelsToShow = this.jewelsToShow === 12 ? 99999 : 12;
      this.setJewelSearch({
        label: "numberOfElements",
        value: this.jewelsToShow,
      });
      if (this.jewelsToShow === 16) {
        this.scrollTo(0);
      }
    },
    setSubCat() {
      this.setJewelSearch({
        label: "backoffice",
        value: this.credential.isBO,
      });
      // if (this.currentCategory && this.currentCategory.id) {
      this.setJewelSearch({
        label: "category",
        value: this.currentCategory.id,
      });

      this.setJewelSearch({
        label: "productType",
        value: this.searchJewel.text ? null : this.currentCategory.productType,
      });
      this.loadFilters();
      this.search(this.searchJewel);
    },
    loadFilters() {
      this.getListSubCategories("subcategories");
      this.getListStoneColors(this.getStonePayload("stone-colors"));
      this.getListStoneShapes(this.getStonePayload("stone-shapes"));
      this.getListGoldTypes("gold-types");
    },
    getStonePayload(url) {
      const payload = {
        search: url,
        params: {
          category: this.currentCategory.id,
          subCategory: this.subCategorySelectedId,
          productType: this.currentCategory.productType,
          jewelStonesNumber: this.buildYourJewelStonesNumber,
        },
      };
      return payload;
    },
    backHome() {
      const root = document.documentElement;
      // if (
      //   this.origin.startsWith("https://shop-test.gioielleriaitaliana.com") ||
      //   this.origin.startsWith("https://shop.gioielleriaitaliana.com")
      // ) {
      //   window.parent.location.href = this.origin;
      // } else {
      this.setJewelsList();
      this.$router.push({ name: "list" });
      // }
      // window.parent.location.href =
      //   document.referrer || document.location.ancestorOrigins[0];
    },
    selectStone(stone) {
      this.stoneTypeSelectedId = stone && stone.color ? stone.color : null;
      this.stoneTypeSelectedLabel = stone && stone.name ? stone.name : null;
      this.resetSearchText();
      this.setJewelSearch({
        label: "stoneColor",
        value: stone ? stone.color : null,
      });
      this.search(this.searchJewel);
      this.scrollTo(0);
    },

    selectStoneShape(shape) {
      this.stoneShapeSelectedId = shape && shape.id ? shape.id : null;
      this.resetSearchText();
      this.setJewelSearch({
        label: "stoneShape",
        value: shape ? shape.id : null,
      });
      this.search(this.searchJewel);
      this.scrollTo(0);
    },

    selectGold(gold) {
      this.goldSelectedId = gold && gold.goldType ? gold.goldType : null;
      this.resetSearchText();
      this.setJewelSearch({
        label: "goldColor",
        value: gold ? gold.goldType : null,
      });
      this.setJewelSearch({
        label: "goldColorId",
        value: gold ? gold.id : null,
      });
      this.search(this.searchJewel);
      this.scrollTo(0);
    },

    searchByRange() {
      this.setJewelSearch({
        label: "minPrice",
        value: this.value[0] / this.retailPerc,
      });
      this.setJewelSearch({
        label: "maxPrice",
        value: this.value[1] === 2000 ? null : this.value[1] / this.retailPerc,
      });
      this.resetSearchText();
      this.search(this.searchJewel);
    },

    resetPriceRenge() {
      this.value = [0, 2000];
      this.searchByRange();
    },

    resetStone() {
      this.stoneTypeSelectedId = null;
      this.stoneTypeSelectedLabel = null;
      this.setJewelSearch({
        label: "stoneColor",
        value: null,
      });
    },

    /*
    resetStoneShape() {
      this.stoneShapeSelectedId = null;ù
      this.setJewelSearch({
        label: "stoneShape",
        value: null,
      });
    },*/

    resetSearchText() {
      this.textToSearch = null;
      this.setJewelSearch({
        label: "text",
        value: null,
      });
      this.setJewelSearch({
        label: "sku",
        value: null,
      });
      this.setJewelSearch({
        label: "category",
        value: this.currentCategory.id,
      });
      this.setJewelSearch({
        label: "productType",
        value: this.currentCategory.productType,
      });
    },

    selectSub(subCategorySelected) {
      this.resetSearchText();
      //this.resetStone();
      this.subCategorySelectedId =
        subCategorySelected && subCategorySelected.id ? subCategorySelected.id : null;

      // if (this.isMobile()) {
      // this.step = 2;

      this.getListStoneColors(this.getStonePayload("stone-colors"));
      this.getListStoneShapes(this.getStonePayload("stone-shapes"));
      // }

      this.setJewelSearch({
        label: "subCategory",
        value: subCategorySelected ? subCategorySelected.id : null,
      });
      this.search(this.searchJewel);
      this.scrollTo(0);
    },

    selectCategory(category) {
      if (this.currentCategory.productType != category.productType) {
        this.resetFilters();
      } else {
        this.resetSearchText();
      }

      this.setJewelSearch({
        label: "category",
        value: category ? category.id : null,
      });
      this.setJewelSearch({
        label: "productType",
        value: category ? category.productType : this.currentCategory.productType,
      });
      this.subCategorySelectedId = null;
      this.setJewelSearch({
        label: "subCategory",
        value: null,
      });

      if (
        !this.buildYourJewelMode &&
        (this.currentCategory.id != category.id ||
          this.currentCategory.productType != category.productType)
      )
        this.$router.replace({
          name: "list.sublist",
          params: {
            productType: category.productType,
            typeId: category ? category.id : null,
          },
          query: {
            section: this.$route.query.section,
          },
        });

      this.setCurrentCategory(category);
      this.search(this.searchJewel);
      this.loadFilters();

      this.scrollTo(0);
    },

    goToJewelDetail(jewel) {
      // if (jewel.productType === ("JEWELLERY" || "GOLDSMITH")) {
      // } else {
      //   this.$router.push({
      //     name: "product.detail",
      //     params: {
      //       sku: jewel.sku,
      //     },
      //   });
      // }

      this.setLastSelectedJewel(jewel.sku);
      this.resetDetail();
      this.resetCurrentJewel();
      this.resetCurrentProduct();
      this.setPreselectedJewel({});

      if (this.buildYourJewelMode) {
        this.selectSetting(jewel);
      } else if (
        jewel.productType === "JEWELLERY" ||
        jewel.productType === "AMA_JEWELLERY" ||
        jewel.productType === "GOLDSMITH" ||
        jewel.productType === "BLISTER"
      ) {
        let queryParams =
          this.searchJewel.minAvailability > 0 ? { fastDelivery: true } : null;

        this.$router.push({
          name: "list.detail",
          params: {
            sku: jewel.sku,
          },
          query: queryParams,
        });
      } else {
        this.$router.push({
          name: "product.detail",
          params: {
            sku: jewel.sku,
            kit: jewel.productType === "KIT",
          },
        });
      }
    },

    resetFilters() {
      this.resetJewelSearch();
      this.goldSelectedId = null;
      this.stoneTypeSelectedId = null;
      this.stoneTypeSelectedLabel = null;
      this.stoneShapeSelectedId = null;
      this.subCategorySelectedId = null;
      this.value = [0, 2000];
    },

    getFilteredCategories(productType) {
      return this.categories.filter(
        (c) => c.id && c.id < 999 && c.productType && c.productType == productType
      );
    },

    getStoneByColor: function (stoneColor) {
      return this.allStoneTypes.find((s) => stoneColor.startsWith(s.color)) || { image: "" };
    },

    onChangeFastDelivery: function (minAvailability) {
      this.resetSearchText();
      if (minAvailability != undefined) this.setMinAvailability(minAvailability);
      else this.setMinAvailability(this.searchJewel.minAvailability > 0 ? 0 : 1);

      this.updateSectionUrl();

      this.search(this.searchJewel);
    },

    setMinAvailability(value) {
      this.setJewelSearch({
        label: "minAvailability",
        value: value,
      });
    },

    toggleSectionFilter: function (sectionValue) {
      let sections = this.searchJewel.jewelSection;
      if (this.isSectionChecked(sectionValue)) {
        sections = sections.filter((section) => section !== sectionValue);
      } else {
        sections.push(sectionValue);
      }

      this.setSectionsFilter(sections, true);
    },

    setSectionsFilter(sections, resetSearchText) {
      if (resetSearchText)
        this.resetSearchText();
      this.setJewelSection(sections);
      this.updateSectionUrl();

      this.search(this.searchJewel);
    },

    setJewelSection(value) {
      this.setJewelSearch({
        label: "jewelSection",
        value: value,
      });
    },

    setExcludeJewelSection(value) {
      this.setJewelSearch({
        label: "excludeJewelSection",
        value: value,
      });
    },

    updateSectionUrl(websiteSection) {
      let urlSections = [...this.searchJewel.jewelSection];
      let excludeUrlSections = [...this.searchJewel.excludeJewelSection];

      if (this.searchJewel.minAvailability > 0) {
        urlSections.push("FAST_DELIVERY");
      }
      let route = {
        name: "list.sublist",
        params: {
          productType: this.$route.params.productType,
          typeId: this.$route.params.typeId,
        },
      };

      if (!!urlSections && urlSections.length > 0) {
        route.query = {
          section: urlSections.join(","),
        };
      }

      if (!!excludeUrlSections && excludeUrlSections.length > 0) {
        if (!route.query) route.query = {};
        route.query.excludeSection = excludeUrlSections.join(",");
      }

      this.$router.replace(route);
    },

    getShapeImage(shape) {
      return require("../assets/stone_shape/" + shape + ".png");
    },

    isSectionChecked(section) {
      return this.searchJewel.jewelSection.includes(section);
    },

    // return per-jewel swiper options so navigation/pagination selectors are scoped to the card
    getJewelSwiperOptions(sku) {
      const opts = Object.assign({}, this.jewelSwiperOptions);
      opts.navigation = {
        nextEl: `#jewel-swiper-${sku} .swiper-button-next`,
        prevEl: `#jewel-swiper-${sku} .swiper-button-prev`,
      };
      opts.pagination = {
        el: `#jewel-swiper-${sku} .swiper-pagination`,
        clickable: true,
      };
      return opts;
    },

    isExcludeSectionChecked(section) {
      return this.searchJewel.excludeJewelSection.includes(section);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.bg-white {
  background-color: white;
}

div.rounded-side-filter {
  border-radius: 0 100em 100em 0;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  height: 40px;
  line-height: 40px;
  margin-bottom: 15px;
}

.swiper-wrapper {
  padding-left: 40px;
  padding-right: 40px;
  margin-bottom: 10px;
}

.swiper-slide {
  background-color: white;
}

.border-item {
  position: relative;
  width: 100%;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  background-color: white;
}

.border-item-2 {
  position: relative;
  width: 100%;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0px 3px 6px #00000029;
}

.name-space {
  .sku {
    font-size: 12px;
  }
}

.name-back {
  background-color: #fff;
  // min-height: 60px;
  padding: 6px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  max-width: 100%;
  width: 100%;
  text-transform: uppercase;
  line-height: normal;

  span {
    color: var(--primary-color-1);
  }

  .name {
    font-size: 12px;
    font-weight: bold;
    min-height: 40px;
    display: block;
  }

  .value {
    font-size: 12px;
  }
}

.inside-stone {
  width: 20px;
  height: 20px;
}

.bg-list {
  background-color: var(--secondary-color-1);
}

.image-list {
  width: 100%;
  height: auto;
  object-fit: cover;
  max-width: 100%;

  .jewel-image {
    width: 100%;
    aspect-ratio: 1/1;
  }
}

.bg-theme-2 {
  background-color: var(--secondary-color-1) !important;
}

@media only screen and (max-width: 768px) {
  .inside-stone {
    width: 15px;
    height: 15px;
  }

  .filter-tag {
    font-size: 12px;
  }
}

@media only screen and (max-width: 576px) {

  .collection-tab /deep/ .nav-item {
    .nav-link {
      padding: 0.25rem 0.5rem;
      font-size: 11px;
    }

    .new-feature {
      font-size: 8px;
    }
  }

  .name-back {
    position: relative !important;
  }

  .border-item {
    height: 100%;
  }

  .bestseller-icon {
    height: 25px !important;
    width: 25px !important;
  }

  .fast-delivery-icon {
    height: 25px !important;
    width: 25px !important;

    img {
      height: 100% !important;
      vertical-align: super !important;
    }
  }
}

.side-part {
  box-shadow: 0px 1px 5px 0px #333333;
}

.side-part-mobile {
  box-shadow: 0px 1px 4px 0px #707070;
  box-shadow: 0px 4px 4px -4px #707070;
}

.side-part-mobile-2 {
  background-color: white;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 10px;
  border-radius: 5%;
}

.titleCatFilter {
  color: var(--primary-color-1);
}

.labelCatFilterDiv {
  padding: 10px;
}

.btn-show-1 {
  box-shadow: 0px 2px 5px 0px #707070;
  font-size: 12px;
}

.btn-show-2 {
  box-shadow: 0px 2px 5px 0px #707070;
  font-size: 12px;
  border-radius: 25px;
}

@media only screen and (min-width: 768px) {
  .border-item {
    position: relative;
    width: 100%;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
  }

  .border-item-2 {
    position: relative;
    width: 100%;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
  }

  .btn-show-1 {
    box-shadow: 0px 2px 5px 0px #707070;
    font-size: 12px;
  }

  .btn-show-2 {
    box-shadow: 0px 2px 5px 0px #707070;
    font-size: 12px;
    border-radius: 25px;
  }

  .name-back {
    background-color: #fff;
    // min-height: 60px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    max-width: 100%;

    span {
      color: var(--primary-color-1) !important;
    }

    .name {
      font-size: 15px;
      line-height: normal;
    }

    .value {
      font-size: 15px;
    }
  }
}

.custom-dot {
  width: 100%;
  height: 100%;
  border-radius: 0;
  transition: all 0.3s;
}

.select-setting {
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  display: initial;
  padding: 2px;
  cursor: pointer;
  //position: absolute;
  // bottom: 8px;
}

.show-all-btn-1 {
  width: 100%;

  //padding-right: 20px;
  button {
    background-color: var(--primary-color-1) !important;
    box-shadow: 0px 2px 5px 0px #707070;
    border: none;

    &.GOLDSMITH {
      background-color: var(--secondary-color-1) !important;
    }

    color: #fff !important;
    border-radius: 50px;
  }
}

.show-all-btn-2 {
  width: 100%;
  padding-right: 20px;

  button {
    background-color: var(--primary-color-1) !important;
    border: 1px solid var(--primary-color-1);

    &.GOLDSMITH {
      background-color: var(--primary-color-1) !important;
    }

    color: #fff !important;
    border-radius: 10px;
  }
}


.jewel-swiper {
  width: 100%;
  padding: 0 !important;

  &.swiper-wrapper {
    margin-bottom: 0px;
  }
}

.jewel-swiper .swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}

.jewel-swiper .jewel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* pagination bullets */
.jewel-swiper-container .swiper-pagination {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 90%;
  line-height: 12px;
  text-align: center;
  z-index: 10;
}

.jewel-swiper-container .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background: rgba(0, 0, 0, 0.3);
  opacity: 1;
  margin: 0 4px !important;
}

.jewel-swiper-container ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: var(--primary-color-1) !important;
}

/* navigation arrows */
.jewel-swiper-container .swiper-button-prev,
.jewel-swiper-container .swiper-button-next {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  z-index: 11;
  top: 50%;
  transform: translateY(-50%);
}

.jewel-swiper-container .swiper-button-prev {
  left: 8px;
}

.jewel-swiper-container .swiper-button-next {
  right: 8px;
}

.jewel-swiper-container .swiper-button-prev::after,
.jewel-swiper-container .swiper-button-next::after {
  font-size: 14px;
}

/* hide arrows on very small screens */
@media (max-width: 576px) {

  .jewel-swiper-container .swiper-button-prev,
  .jewel-swiper-container .swiper-button-next {
    display: none;
  }
}

.filters-tags {
  .filter-tag {
    background-color: var(--secondary-color-1) !important;
    color: var(--primary-color-1);
    padding: 8px;
    margin-right: 10px;
    white-space: nowrap;
    display: inline-block;
    margin-bottom: 5px;

    .label {
      margin-right: 10px;
      text-transform: uppercase;
    }

    .remove-filter-icon {
      cursor: pointer;
    }
  }

  margin: 15px 0px;
  text-align: left;
}

.jewel-stone-colors {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  // margin-bottom: 8px;
  position: relative;
}

.icons {
  position: absolute;
  top: 20px;
  z-index: 2;
}

.fast-delivery-icon {
  background-color: var(--secondary-color-1);
  padding: 5px;
  margin-bottom: 10px;

  img {
    height: 30px;
  }
}

.bestseller-icon {
  top: 75px;
  z-index: 1;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border: 1px solid var(--primary-color-1);
  border-left: 0;

  img {
    height: 30px;
  }
}

.vue-js-switch::v-deep {
  &.toggled {
    .v-switch-core {
      background-color: var(--secondary-color-1);
    }
  }

  .v-switch-core {
    background-color: rgb(191, 203, 217);
  }
}

.stone-type-title {
  margin-bottom: 0px;
  margin-top: 1.3em;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.9em;
}

.results.ama-results {
  background: var(--ama-gray);
}

.results {
  margin-top: 0 !important;
  background: #f0f0ef;
  padding-bottom: 20px;

  .side-part {
    box-shadow: none;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background-color: white;
  }

  .rounded-side-filter {
    box-shadow: none;
    border-bottom: 1px solid var(--secondary-color-1);
    border-radius: 0;
    height: unset;
  }

  .labelCatFilterDiv {
    display: table;
    width: 100%;
  }

  .labelCatFilter {
    display: table-cell;
    text-transform: uppercase;
    color: var(--primary-color-1);
    font-size: 15px;
  }

  .form-check-input {
    display: table-cell;
    text-align: right;
    margin-left: 0;
  }

  .titleCatFilter {
    margin-top: 20px;
    margin-bottom: 10px;
    line-height: normal;
  }

  .subcategory-mobile {
    background-color: white;
  }
}

.mobile-stone {
  margin-top: 10px;
  border-radius: 100%;
  overflow: hidden;
}

.tabs-section {
  margin-top: -10px;
}

.collection-tab {
  width: 100%;
}

.collection-tab /deep/ .nav-item {
  flex: 1 1 50%;
  max-width: 50%;
  text-align: center;

  .nav-link {
    padding-top: 2rem;
    padding-bottom: 2rem;
    border: 2px solid var(--ama-green);
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    background-color: white;
    color: var(--ama-green);
    font-weight: bold;
    text-transform: uppercase;

    &.active {
      background-color: var(--ama-green);
      color: white !important;
    }

    &:not(.active):hover {
      background-color: #f2f6f3;
      color: var(--ama-green) !important;
    }
  }
}

.breadcrumb-list {
  border-bottom: 0 !important;
}

.new-feature {
  vertical-align: text-top;
  margin-left: 5px;
}
</style>
